import React from 'react'
import { BsFillPatchCheckFill } from "react-icons/bs"
import './Experience.css'

const Experience = () => {
  return (
    // <section id='experience'>

    //   <h5> what Skills I Have</h5>
    //   <h2>MY Experiesce</h2>
    //   <div className='container experience__container'>
    //   <div className="experience__frontend">
    //     <h3>Frontend Development</h3>
    //     <div className="experience__content">
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <div>
    //         <h4>HTML</h4>
    //         <small className='text-light'> Experienced</small>
    //         </div>
    //       </article>
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <div>
    //         <h4>CSS</h4>
    //         <small className='text-light'> Experienced</small>
    //         </div>
    //       </article>
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <div>
    //         <h4>Bootstrap</h4>
    //         <small className='text-light'> Experienced</small>
    //         </div>
    //       </article>
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <div>
    //         <h4>React</h4>
    //         <small className='text-light'> Experienced</small>
    //         </div>
    //       </article>
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <div>
    //         <h4>Tailwind</h4>
    //         <small className='text-light'> Experienced</small>
    //         </div>
    //       </article>
    //     </div>


    //   </div>
    //   <div className="experience__backend">
      
    //     <h3>Backend Development</h3>
    //     <div className="experience__content">
    //     <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <h4>JavaScript</h4>
    //         <small className='text-light'> Experienced</small>
    //       </article>
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <h4>Django</h4>
    //         <small className='text-light'> Experienced</small>
    //       </article>
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <h4>Node Js</h4>
    //         <small className='text-light'> Experienced</small>
    //       </article>
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <h4>mongoDB</h4>
    //         <small className='text-light'> Experienced</small>
    //       </article>
    //       <article className='experience__details'>
    //         <BsFillPatchCheckFill className="experience__detail-icons"/>
    //         <h4>SQL</h4>
    //         <small className='text-light'> Experienced</small>
    //       </article>
    //     </div>

    //   </div>

    //   </div>
    // </section>


    <section id='experience'>
  <h5>What Skills I Have</h5>
  <h2>My Experience</h2>
  <div className='container experience__container'>
    
    <div className="experience__frontend">
      <h3>Frontend Development</h3>
      <div className="experience__content">
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>HTML</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>CSS</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Bootstrap</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>React</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Next.js</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>React Native</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Expo</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Flutter</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Tailwind</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Shadcn</h4><small className='text-light'>Experienced</small></div></article>
      </div>
    </div>
    
    <div className="experience__backend">
      <h3>Backend Development</h3>
      <div className="experience__content">
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Node.js</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Express.js</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Firebase</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>MYSQL</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>NoSQL</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>REST API</h4><small className='text-light'>Experienced</small></div></article>
      </div>
    </div>
    
    <div className="experience__programming-languages">
      <h3>Programming Languages</h3>
      <div className="experience__content">
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Java</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Python</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>JavaScript</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>TypeScript</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>C#</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>C++</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>C</h4><small className='text-light'>Experienced</small></div></article>
      </div>
    </div>
    
    <div className="experience__other">
      <h3>Other Skills</h3>
      <div className="experience__content">
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Cloud Computing (AWS)</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Game Development (Unity 2D, Godot)</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Machine Learning</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Microservices</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Distributed Systems</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>CI/CD</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Jenkins</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Unit Testing</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>OOP</h4><small className='text-light'>Experienced</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>AI</h4><small className='text-light'>Experienced</small></div></article>
      </div>
    </div>
    
    <div className="experience__languages">
      <h3>Languages</h3>
      <div className="experience__content">
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>English</h4><small className='text-light'>Professional Proficiency</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Hindi</h4><small className='text-light'>Professional Proficiency</small></div></article>
        <article className='experience__details'><BsFillPatchCheckFill className="experience__detail-icons"/><div><h4>Marathi</h4><small className='text-light'>Professional Proficiency</small></div></article>
      </div>
    </div>
  </div>
</section>
  )
}

export default Experience